import { Product, ProductCost, ProductParameter, ProductParameterValue } from '../product/model'
import { ProductBuilderNotification } from './model'
import { ProductBuilderAction } from './actions'

export interface ProductBuilderState {
    dispatch?: (action: { type: ProductBuilderAction, params?: any }) => void
    loading?: boolean
    loadingCounter?: number
    notifications?: ProductBuilderNotification[]
    product?: Product
    productCost?: ProductCost[]
    productParameters?: ProductParameter[]
    productParameterLabels?: { [key: string]: string }
    productParameterExpandedKey?: string | undefined
    productParameterOptions?: { [key: string]: ProductParameterValue[] }
    productParameterValues?: ProductParameterValue[]
    stepIndex?: number
    backToDefaultSettings?: boolean
    resetSetBackToDefaultSettings?: () => void
    removeUploadedFiles?: (files: UploadedFiles[], config: object, key: string) => void
}

export interface UploadedFiles {
    id: number
    url: string
}

export const productBuilderStateInitial: ProductBuilderState = {
    loading: false,
    loadingCounter: 0,
    notifications: [
        {
            title: 'Notify title',
            content: 'The table above present the typical configuration of this product. You can tailor the given product to your individual needs by changing its features. Click \'<b>CHANGE</b>\' button next to each feature to update its parameters.'
        }
    ],
    productCost: [],
    productParameterOptions: {},
    productParameterValues: [],
    stepIndex: 0,
}
